export { }
declare global {


    interface String {
        toWordPrice(): String
    }

}






String.prototype.toWordPrice = function (): String {
    let size = this.length
    let number = Number.parseInt(this.toString())
    if (size <= 3) {
        return `${number}`
    } else if (size > 3 && size <= 6) {
        return `${number / 1000}` + " هزار"

    } else if (size > 6 && size <= 9) {
        return `${number / 1000000}` + " میلیون"

    } else if (size > 9 && size <= 12) {
        return `${number / 1000000000}` + " میلیارد"

    } else if (size > 12 && size <= 15) {
        return `${number / 1000000000000}` + " بیلیون"

    } else if (size > 15 && size <= 18) {
        return `${number / 1000000000000000}` + " بیلیارد"

    } else {
        return `${number / 1000000000000000000}` + " تریلیون"

    }
}